export class UploadDatabaseLogsRequest {
    NumberOfDays: number;
    LicenseKey: string;
}
